<template>
    <div class="pt-0 p-2">
        <div class="position-relative">
            <form class="h-100" @submit.prevent="submitForm">
                <div class="rounded-pill bg-white shadow-sm pl-3 p-2 border-faded d-flex flex-row align-items-center justify-content-start flex-shrink-0">
                    <img class="profile-image-lg img-thumbnail img-responsive rounded-circle" :src="breakObj.icon != '' ? getIcon(breakObj.icon) : require('@/assets/image/icon/profile.png')"/>
                    <div class="ml-5 m-1">
                        <h5 class="text-primary mb-1">
                            {{breakObj.name}}
                            <small class="mt-2 text-dark mb-0 fw-300">
                                <span class="d-block">
                                    <i class="fal fa-phone-alt mr-2 "></i>
                                    +{{breakObj.mobile}}
                                </span>
                                <i class="fal fa-store mr-2"></i>
                                {{outlet.text}}
                            </small>
                        </h5>
                    </div>
                </div>
                <div v-if="Object.keys(breakObj).length != 0" class="border-top pt-3 p-2 mt-4">
                    <h4 class="fw-700 mb-1">
                        <i class="fal fa-calendar-alt mr-2"></i>
                        {{$t('header.slot')}}: {{convertTimestampToDateDay(breakObj.break[0].breakDate)}}
                    </h4>
                    <h5 class="mb-3 fw-300">
                        <i class="fal fa-tags mr-1"></i>
                        {{$t('table.header.type')}}: {{breakObj.break[0].DfBreakTypeTitle}}
                    </h5>
                    <div class="form-group">
                        <label class="form-label">{{$t('table.action')}}</label>
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text bg-transparent border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                <i class="fas fa-hand-point-up"></i>
                            </label>
                            <multiselect v-model="selectedAction" label="text" track-by="id" :options="action" :searchable="false" :show-labels="false" openDirection="below" @select="selectAction">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="mb-5" v-show="selectedAction.id == 'delete' && breakItems.length != 0">
                        <p class="text-primary mb-1 fw-300">{{$t('outlet_setting.roster.other_off_day', {'name': breakObj.name})}}</p>
                        <div class="form-group mb-2">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="deleteMultiple" v-model="deleteMultiple">
                                <label class="custom-control-label" for="deleteMultiple">{{$t('button_link.delete_multiple')}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 overflow-auto">
                                <b-table small striped hover bordered :fields="fields" :items="breakItems" responsive>
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <template #cell(breakDate)="data">
                                        {{convertTimestampToDateDay(data.item.breakDate)}}
                                    </template>
                                    <template #cell(status)="data">
                                        <span class="badge" :class="data.item.rejectedDate == 0 && data.item.approved == 0 ? 'badge-warning' : data.item.rejectedDate == 0 ? 'badge-primary' : 'badge-danger'">
                                            {{data.item.rejectedDate == 0 && data.item.approved == 0 ? $t('outlet_setting.roster.pending') : data.item.rejectedDate == 0 ? $t('outlet_setting.roster.approved') :  $t('outlet_setting.roster.rejected')}}
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button-container">
                    <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnRoster">{{$t('button_link.cancel')}}</button>
                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{selectedAction.text}}</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "staffRosterActionForm",
    data(){
        return{
            breakObj: {},
            action: [],
            outlet: {},
            deleteMultiple: 0,
            selectedAction: {},
            breakItems: []
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed text-center', tdClass: 'text-center'},
                { key: "breakDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "DfBreakTypeTitle", label: this.$i18n.t('table.header.type'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "status", label: this.$i18n.t('outlet_setting.roster.status'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
            ]
        },
    },
    methods: {
        closeModal(isError){
            if(!isError){
                this.returnRoster()
            }
            this.$parent.$parent.isModalShow = false
        },
        getIcon(img){
            return img
        },
        convertTimestampToDateDay(ts){
            return moment(ts*1000).format('ddd, DD/MM/YYYY')
        },
        setAction(){
            this.action = []
            if(this.breakObj.break[0].rejectedDate == 0 && this.breakObj.break[0].approvedDate == 0){
                this.action = [
                    {
                        id: 'approve',
                        text: this.$i18n.t('outlet_setting.roster.approve')
                    },
                    {
                        id: 'reject',
                        text: this.$i18n.t('outlet_setting.roster.reject')
                    }
                ]
            }else{
                if(this.breakObj.break[0].rejectedDate != 0){
                    this.action.push({
                        id: 'approve',
                        text: this.$i18n.t('outlet_setting.roster.approve')
                    })
                }else{
                    this.action.push({
                        id: 'reject',
                        text: this.$i18n.t('outlet_setting.roster.reject')
                    }) 
                }
            }
            
            this.action.push({
                id: 'delete',
                text: this.$i18n.t('outlet_setting.roster.delete')
            }) 
            this.selectedAction = this.action[0]
        },
        selectAction(item){
            this.selectedAction = item
        },
        async setStaffRosterActionForm(obj, outlet, date){
            var breakObj = obj.break.filter(obj=> moment(obj.breakDate*1000).format('DD/MM/YYYY') == moment(parseInt(date)*1000).format('DD/MM/YYYY'))
            obj.break = breakObj
            
            this.breakObj = obj
            this.outlet = outlet
            let QUERY_STRING = '?identifier=' + obj.break[0].identifier
            var result = await this.getStaffRoster(QUERY_STRING)

            this.setAction()
            this.breakItems = result.filter(o=> o.breakID != obj.break[0].breakID)
            this.breakItems.sort((a, b) => a.breakDate - b.breakDate);
        },
        async getStaffRoster(QUERY_STRING){
            let $vm = this;
            const url =  this.$api.STAFF_ROSTER + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result          
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        submitForm(){
            var data = {}
            let url = this.$api.STAFF_ROSTER
            if(this.selectedAction.id == 'delete'){
                if(this.deleteMultiple){
                    data.identifier = this.breakObj.break[0].identifier
                    url += this.$api.DELETE
                }else{
                    url+= ("/" + this.breakObj.break[0].breakID + "/" + this.selectedAction.id)
                }
            }else{
                url+= ("/" + this.breakObj.break[0].breakID + "/" + this.selectedAction.id)
            }
            
            let $vm = this; 
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then(function(response) {
               if(response.status == 200){
                   var action = $vm.selectedAction.id == 'approve' ? 'approved' : 'rejected'
                    var message = $vm.$i18n.t('outlet_setting.roster.off_day') + $vm.$i18n.t('message.success.success', {'action': $vm.selectedAction.id == 'delete' ? $vm.$i18n.t('message.success.action.delete') : ($vm.$i18n.t(`outlet_setting.roster.${action}`)).toLowerCase()})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }        
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        returnRoster(){
            this.$emit('returnRoster')
        }
    },
}
</script>
<style>
.profile-image-lg{
    width: 5em;
    height: 5em;
}
.button-container{
    width: 100%;
    position: absolute;
    border-top: 1px solid #f1f1f1;
    padding-top: 2em;
    padding-bottom: 3em;
    text-align: center;
}
</style>